import React, { Component } from "react";

class ExaVault extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    const user = JSON.parse(localStorage.getItem("user")) || {};
    const userHash = user.user_hash || "";
    script.src = `https://photoncommerce.exavault.com/share/widget/${userHash}`;
    script.async = true;
    document.body.appendChild(script);
  }

  render() {
    return <React.Fragment></React.Fragment>;
  }
}

export default ExaVault;
